import './sign-in.styles.css';
import {Grid, InputAdornment, Stack} from '@mui/material';

import Logo from '../../assets/logo.png';
import TextInputField from '../../components/input/text-input-field.component';
import ActionButton from '../../components/button/button.component';
import Typography from '@mui/material/Typography';
import {useDispatch} from 'react-redux';
import React, {useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import sendApiRequest, {NetworkMethods} from '../../lib/Network';

import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";
import {z} from "zod";
import IconButton from "@mui/material/IconButton";

import VisibilityEnable from "@mui/icons-material/RemoveRedEye";
import VisibilityDisable from "@mui/icons-material/VisibilityOff";
import {setCurrentUser} from "../../store/reducers/user/user.reducer";
import {ApiResponseModel} from "../../models/apiresponse.model";

export default function SignIn() {
    const recaptcha = useRef<ReCAPTCHA>(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSent, setIsSent] = useState<boolean>(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

    const onEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const blockSubmitButton = () => {
        setIsSent(true);
        setTimeout(() => {
            setIsSent(false);
        }, 6000);
    }

    const onSubmit = async () => {
        const captchaValue = recaptcha?.current?.getValue();
        if (!captchaValue) {
            toast.error("Hoops! Nem pipáltad ki a nem vagyok robot gombot!");
            blockSubmitButton();
            return;
        }

        if (!(email && password)) {
            toast.error("Hoops! Nem pipáltad ki a nem vagyok robot gombot!");
            blockSubmitButton();
            return;
        }

        try {
            /* validate e-mail */
            const emailSchema = z.string().email();
            const emailAddress = email;
            emailSchema.parse(emailAddress);

            const response = await sendApiRequest({
                method: NetworkMethods.POST,
                endpoint: 'user/sign-in',
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                },
                payload: {
                    email: email,
                    password: password,
                },
            });

            if (!response.isSuccess) {
                toast.error('Hiba! Sikertelen belépés! Ellenőrizd az adataidat!');
                setEmail('');
                setPassword('');
                return;
            }

            let apiResponse: ApiResponseModel = response.data;

            console.log('user signed in: ', apiResponse)

            // User signed in.
            dispatch(setCurrentUser(apiResponse.data));

            // Navigate user to home page.
            navigate('/');
        } catch (e: any) {
            toast.error('Hiba! Sikertelen belépés! Ellenőrizd az adataidat!');
            blockSubmitButton();
        }
    };

    return (
        <Stack
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            className={"auth-layout"}
        >
            <Stack
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                className={"auth-inner-box"}
            >
                <img src={Logo} className="auth-image" alt={'Kőszegszerdahely Római Katolikus Plébánia'}/>
                <Typography variant="h3" textAlign="center" className={"auth-title"}>
                    Kőszegszerdahely Római Katolikus Plébánia
                </Typography>
                <br/>
                <br/>

                <TextInputField
                    title={"E-mail cím *"}
                    variant="DARK"
                    value={email}
                    onChange={onEmailChange}
                />
                <TextInputField
                    title={"Jelszó *"}
                    type={!isPasswordVisible ? "password" : "text"}
                    variant="DARK"
                    value={password}
                    onChange={onPasswordChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position={"end"}>
                                <IconButton
                                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                >
                                    {isPasswordVisible ? (
                                        <VisibilityEnable/>
                                    ) : (
                                        <VisibilityDisable/>
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <br/>
                <ReCAPTCHA
                    ref={recaptcha}
                    sitekey={`${process.env.REACT_APP_SITE_KEY}`}
                />
                { /**/ }
                <br/>
                <ActionButton
                    title={'Bejelentkezés'}
                    type="SIGN_IN"
                    action={onSubmit}
                    disabled={isSent}
                />
                <br/>
            </Stack>
        </Stack>
    );
}